export class ProjectAreaOfFocus {

    constructor(projectAreaOfFocusId:string = "", name:string = "", description:string = "") {
        this.ProjectAreaOfFocusId = projectAreaOfFocusId;
        this.Name = name;
        this.Description = description;
    }
    
    public ProjectAreaOfFocusId: string;
    public Name: string;
    public Description: string;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/project-area-of-focus.ts